// Shared shape/helpers for the "matching" interactive block type - each
// side of a pair can now be plain text OR a media reference (image/audio/
// video), any combination on either side, not just text-to-text like the
// original version of this type. Used by both the builder editor
// (block-editors/MatchingEditor.jsx) and the student-facing interactive
// game (courses/preview/interactivePreviews.jsx) so the two can't drift on
// what a pair means.

export const MATCHING_SIDE_KIND_TEXT = 'text';
export const MATCHING_SIDE_KIND_IMAGE = 'image';
export const MATCHING_SIDE_KIND_AUDIO = 'audio';
export const MATCHING_SIDE_KIND_VIDEO = 'video';

export const MATCHING_SIDE_KIND_LIST = [
    { key: MATCHING_SIDE_KIND_TEXT, label: 'Текст' },
    { key: MATCHING_SIDE_KIND_IMAGE, label: 'Фото' },
    { key: MATCHING_SIDE_KIND_AUDIO, label: 'Аудіо' },
    { key: MATCHING_SIDE_KIND_VIDEO, label: 'Відео' },
];

// mediaWidth/mediaHeight: CSS length strings (same px/% convention as
// variables/containerLayoutTypes.js's parseLength/formatLength) sizing any
// image/video chip in the preview - audio only ever uses mediaWidth
// (players don't need a configurable height).
// mode: how the student's connections are handled.
//  'live'     (default, also what every config without `mode` means) - a
//             pick is checked the moment it's made: a correct pair locks in
//             and only correct pairs are ever saved (resultJson
//             {matched:[pairId], matchColors}), a wrong pick just flashes.
//  'deferred' - the student may connect ANY left to ANY right, nothing is
//             judged while answering, and correctness only shows after the
//             "Перевірити" button. Wrong connections are therefore real
//             state and get saved: resultJson {connections:[{left,right}]},
//             left/right = pair index into config.pairs (a connection is
//             correct iff left === right).
export const MATCHING_MODE_LIVE = 'live';
export const MATCHING_MODE_DEFERRED = 'deferred';
export const MATCHING_MODE_LIST = [
    { key: MATCHING_MODE_LIVE, label: 'Одразу показувати правильність' },
    { key: MATCHING_MODE_DEFERRED, label: 'Правильність лише після «Перевірити»' },
];
export function getMatchingMode(cfg) {
    return cfg && cfg.mode === MATCHING_MODE_DEFERRED ? MATCHING_MODE_DEFERRED : MATCHING_MODE_LIVE;
}

export const MATCHING_DEFAULT_CONFIG = {
    mode: MATCHING_MODE_LIVE,
    pairs: [
        { left: { kind: MATCHING_SIDE_KIND_TEXT, value: '' }, right: { kind: MATCHING_SIDE_KIND_TEXT, value: '' } },
    ],
    mediaWidth: '140px',
    mediaHeight: '100px',
};

// Pairs created before media support existed stored left/right as plain
// strings - normalize both that legacy shape and the current {kind,value}
// object shape into one consistent shape, so every consumer (editor,
// builder preview, student game) only ever has to handle one.
export function normalizeSide(side) {
    if (side && typeof side === 'object') {
        return { kind: side.kind || MATCHING_SIDE_KIND_TEXT, value: side.value || '' };
    }
    return { kind: MATCHING_SIDE_KIND_TEXT, value: typeof side === 'string' ? side : '' };
}

export function normalizePairs(pairs) {
    return (pairs || []).map((pair) => ({
        left: normalizeSide(pair.left),
        right: normalizeSide(pair.right),
    }));
}

export function isSideFilled(side) {
    return !!(side.value && side.value.trim());
}
